import { render, staticRenderFns } from "./ModalInformacion.vue?vue&type=template&id=094fadfb"
import script from "./ModalInformacion.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInformacion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports